import { useCallback } from "react"

const useUpdateForm = (setValue: (e: any) => void) => {
    const updateHandler = useCallback((newData: any,) => {
        const _data = { ...newData };
        setValue(_data)
    }, [])
    return updateHandler as (data: any) => void;
}
export default useUpdateForm